import { render, staticRenderFns } from "./CardInfo2.vue?vue&type=template&id=0d0c7d6c"
import script from "./CardInfo2.vue?vue&type=script&lang=js"
export * from "./CardInfo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports